.spinner {
  display: inline-block;
  flex: none;
  inline-size: 1rem;
  block-size: 1rem;
  border: 2px solid currentColor;
  border-inline-end-color: transparent;
  border-radius: var(--wv-radius-full);
  animation: spin 700ms linear infinite;
}

.spinner[data-size="sm"] {
  inline-size: 0.75rem;
  block-size: 0.75rem;
}

.spinner[data-size="lg"] {
  inline-size: 1.5rem;
  block-size: 1.5rem;
  border-width: 3px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 2s;
  }
}
